const unknownError = 'Unknown error';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getErrorMessage(error) {
    if (typeof error === 'string') {
        return error || unknownError;
    }
    else if (error != null && typeof error === 'object' && typeof error.message === 'string') {
        return error.message || unknownError;
    }
    else if (error != null && typeof error.toString() === 'function') {
        try {
            const message = error.toString();
            if (typeof message === 'string') {
                return message || unknownError;
            }
        }
        catch (e) {
            console.error('Failed to call toString on error object', e);
        }
    }
    return unknownError;
}
